<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-header>
        <el-tabs
          v-model="groupTabsValue"
          @tab-click="handleClick"
          class="custom-tabs"
        >
          <el-tab-pane
            :key="item.id"
            v-for="item in groubTabs"
            :label="item.areaName"
            :name="item.areaCode"
          >
          </el-tab-pane>
        </el-tabs>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <LightPanelView
          :areaCode="selectAreaCode"
          ref="panel"
          @offLine="judgeOffline"
        ></LightPanelView>
      </zj-layout-main>
      <el-footer
        style="display: flex; align-items: center; justify-content: end"
      >
        <div style="text-align: center; flex: 1" v-show="false">
          <el-button type="primary" @click="allOpen" :disabled="offLine"
            >全开</el-button
          >
          <el-button @click="allClose" :disabled="offLine">全关</el-button>
        </div>
        <div class="switchSet">
          <el-switch
            v-model="autoControl"
            active-color="#298beb"
            inactive-color="#a0a8b5"
            active-text="自动控制"
            @change="autoControlChange"
            :disabled="isDisableControl"
          >
          </el-switch>
          <div class="setting" @click="goConfig"></div>
        </div>
      </el-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import {
  getEquipmentCode,
  listEquipment,
  listEquipmentArea,
  controlDevice,
} from "@/api/src/equipment";
import LightPanelView from "./components/LightPanelView";

import {
  listSmartLightSetting,
  updateSmartLightSetting,
} from "@/api/src/smartLightSetting";
export default {
  name: "LightControl",
  controller: "UI",
  action: "LightControl",
  components: {
    LightPanelView,
  },
  data() {
    return {
      groubTabs: [{ areaName: "全部", areaCode: "0", id: "0" }],
      groupTabsValue: this.$route.query.areaCode || "0",
      //设备信息
      lightAllList: [],
      autoControl: false,
      selectAreaCode: this.$route.query.areaCode || "0",
      code: null,
      smartLightSettingList: [],
      smartLightSettingData: {},
      isDisableControl: false,
      offLine: false, //是否全部离线
      loading: false,
      loadingText: "加载中...",
    };
  },
  created: function () {
    this.init();
  },
  mounted: function () {},

  methods: {
    // 获取设备code
    init() {
      getEquipmentCode("lightEquipment").then((response) => {
        this.code = response.data;
        this.initTab();
      });
    },
    // 初始化
    initTab() {
      const that = this;
      listEquipmentArea({ categoryCode: this.code, pageSize: 100 }).then(
        (response) => {
          that.groubTabs = [{ areaName: "全部", areaCode: "0", id: "0" }];
          response.data.forEach((element) => {
            that.groubTabs.push(element);
          });

          this.listSmartLightSetting();
        }
      );
    },
    // 查询
    getList() {
      this.loading = true;

      listEquipment({ categoryCode: this.code, pageSize: 10000 }).then(
        (response) => {
          this.lightAllList = response.rows;

          this.loading = false;
        }
      );
    },
    handleClick(tab, event) {
      this.selectAreaCode = tab.name;
      this.listSmartLightSetting();
      this.getAllSmartSettingStatus();
    },
    goConfig() {
      this.$router.push({
        path: "/plugin/light/UI/LightControlConfig",
        query: {
          areaCode: this.selectAreaCode,
          autoControl: this.autoControl,
          isDisableControl: this.isDisableControl,
        },
      });
    },
    //查看本分区是否能自动控制
    listSmartLightSetting() {
      listSmartLightSetting({
        areaCode: this.selectAreaCode,
        pageSize: 100,
      }).then((response) => {
        if (response.rows.length > 0) {
          // this.data = response.rows[0];

          this.smartLightSettingList = response.rows;
          this.smartLightSettingData = response.rows[0];
          this.autoControl = this.smartLightSettingData.status === "1";
        } else {
          this.smartLightSettingData = null;
          this.autoControl = false;
        }
      });
    },
    //查看全局自动控制状态
    getAllSmartSettingStatus() {
      listSmartLightSetting({
        areaCode: "0",
      }).then((response) => {
        if (response.rows.length > 0) {
          //当全局自动控制打开时，分组控制不可打开，不可编辑
          this.isDisableControl =
            response.rows[0].status === "1" && this.selectAreaCode != "0";
        } else {
          this.isDisableControl = false;
        }
      });
    },
    //查看是否有分组在使用自动控制
    listAllSmartLightSetting() {
      listSmartLightSetting({
        pageSize: 100,
      }).then((response) => {
        const settings = response.rows.filter(
          (a) => a.areaCode != "0" && a.status == "1"
        );
        if (settings.length > 0) {
          this.$confirm(
            "有分组在使用自动控制，全局规则将覆盖分组规则，确认打开吗?",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
            .then(() => {
              this.smartLightSettingData.status = "1";
              this.updateSmartLightSetting(this.smartLightSettingData, true);
              this.goConfig();
            })
            .catch(() => {
              this.autoControl = false;
              this.$message({
                type: "info",
                message: "已取消",
              });
            });
        } else {
          this.smartLightSettingData.status = "1";
          this.updateSmartLightSetting(this.smartLightSettingData, true);
          this.goConfig();
        }
      });
    },
    //全开
    allOpen() {
      this.$confirm("确定要全部打开吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.controlDevice("2"); //instructions指令 2 开 1 关
          this.loading = true;
          this.loadingText = "打开中...";
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消打开",
          });
        });
    },
    //全关
    allClose() {
      this.$confirm("确定要全部关闭吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.loadingText = "关闭中...";
          this.controlDevice("1"); //instructions指令 2 开 1 关
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消关闭",
          });
        });
    },
    //智能控制
    controlDevice(instructions) {
      let paramData = {
        areaCode: this.selectAreaCode, //全开，全关的话， areaCode就传那个分区code;
        categoryCode: this.code, //单个的， categoryCode和areaCode不用传
        instructions: instructions, //指令 2 开 1 关
        equipmentCode: null, //全部的话equipmentCode不用传
      };
      controlDevice(paramData)
        .then((response) => {
          this.$message({
            type: "success",
            message: instructions === "2" ? "打开成功" : "关闭成功",
          });
          this.loading = false;
          //更新设备状态
          this.$refs.panel.getList();
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    //自动控制切换
    autoControlChange(val) {
      if (val) {
        if (this.selectAreaCode === "0") {
          this.listAllSmartLightSetting();
        } else {
          this.updateSmartLightSetting(this.smartLightSettingData, true);
          this.goConfig();
        }
      } else {
        let autoControlName = "";
        if (
          this.smartLightSettingData &&
          this.smartLightSettingData.autoControlTranslated != null
        ) {
          autoControlName =
            "<" + this.smartLightSettingData.autoControlTranslated + ">,";
        }
        this.$confirm(
          "关闭自动控制后，" + autoControlName + "确认关闭自动控制吗？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            this.smartLightSettingData.status = "2";
            this.updateSmartLightSetting(this.smartLightSettingData, false);
          })
          .catch(() => {
            this.autoControl = true;
            this.$message({
              type: "info",
              message: "已取消关闭",
            });
          });
      }
    },
    updateSmartLightSetting(data, isOpen) {
      if (data) {
        updateSmartLightSetting(data)
          .then((response) => {
            this.$message({
              type: "success",
              message: isOpen ? "打开成功" : "关闭成功",
            });
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
  beforeDestroy() {
    //在实例销毁之前，移除监听器
    //Bus.$off("backLightPanel");
  },
};
</script>

<style lang="css" scoped>
</style>>


